<script lang="ts" setup>
	type ProductCategories = 'gadget' | 'travel' | 'auto'
	const props = defineProps<{
		category: ProductCategories
		title?: string
	}>()

	const content = computed<
		Record<
			ProductCategories,
			{
				label: string
				icon: {
					dir: string
					name: string
				}
			}
		>
	>(() => ({
		gadget: {
			label: "Protect your team's gadgets, stay connected and <span class='text-gadget-600'>worry-free!</span>",
			icon: {
				dir: 'random',
				name: 'gadget-smile'
			}
		},
		auto: {
			label: "<span class='text-auto-500'>Affordable plans</span> to <br /> protect your vehicles from risks",
			icon: {
				dir: 'random',
				name: 'auto-tag'
			}
		},
		travel: {
			label: "Peace of mind for your <br /><span class='text-travel-500'>team's trips!</span>",
			icon: {
				dir: 'random',
				name: 'travel-tag'
			}
		}
	}))
	const activeLabel = computed(() => {
		if (props.category && content.value?.[props.category]) {
			return content.value[props.category]
		}
		return null
	})
</script>
<template>
	<div>
		<div class="flex items-center justify-evenly flex-wrap gap-6">
			<tools-icon
				:dir="String(activeLabel?.icon?.dir)"
				:icon="String(activeLabel?.icon?.name)"
				svg-class="md:h-[414px] md:w-[358px] h-[213px] w-auto"
			/>
			<ui-title-header
				class="inline"
				:ui="{
					size: 'md:text-[4em] text-[2em] max-w-[803px] sm:text-left text-center text-balance',
					lineHeight: 'md:leading-[89.6px] leading-[38.4px]'
				}"
			>
				<span v-html="title ?? activeLabel?.label ?? 'N/A'" />
			</ui-title-header>
		</div>
	</div>
</template>
